import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';

interface ImageGalleryModalProps {
  open: boolean;
  onClose: () => void;
  images: string[];
}

export const ImageGalleryModal: React.FC<ImageGalleryModalProps> = ({ open, onClose, images }) => {
  const imageSize = 500;
  const gapSize = 12;

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageClick = (src: string) => {
    setSelectedImage(src);
  };

  const handleCloseSelectedImage = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: 1,
            borderRadius: 4,
            maxHeight: '90%',
            overflowY: 'auto',
            display: 'grid',
            gridTemplateColumns: `repeat(3, ${imageSize}px)`,
            gap: `${gapSize}px`,
            justifyContent: 'center',
          }}
        >
          {images.map((src, idx) => (
            <Box
              key={idx}
              sx={{
                width: imageSize,
                height: imageSize,
                overflow: 'hidden',
                borderRadius: 2,
                backgroundColor: '#000',
                position: 'relative',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.01)',
                },
              }}
              onClick={() => handleImageClick(src)}
            >
              <img
                src={src}
                alt={`Image ${idx}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          ))}
        </Box>
      </Modal>

      <Modal
        open={Boolean(selectedImage)}
        onClose={handleCloseSelectedImage}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          onClick={handleCloseSelectedImage}
          sx={{
            backgroundColor: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '110%',
            height: '100%',
          }}
        >
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Selected"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};
